<template>
  <app-dropdown class="date-range-filter"
                :data-title="$t('message.generics.message.period')"
                data-menu-width="445px"
                :data-button-gradient="true">

    <h3 class="mb-3 text-bold">{{$t('message.generics.message.period')}}</h3>

    <div class="date-range-filter-body flex-center">
      <app-tab-selector :data-tabs="tabs"
                        v-model="value"
                        class="mb-3"></app-tab-selector>

      <button v-if="!custom"
              class="btn-gradient btn-gradient-thin"
              @click="custom = true">

        <div class="btn btn-extra-round btn-stretch text-bold">
            {{$t('message.generics.message.custom')}}
        </div>

      </button>
    </div>

    <template v-if="custom">

      <h3 class="mb-3 text-bold">{{$t('message.generics.message.custom')}}</h3>

      <div class="flex flex-center">
        <app-box-wrapper class="mb-4"
                         :data-label="$t('message.generics.message.startDate')"
                         data-icon="mdi-calendar-range">

          <app-date-picker v-model="min"></app-date-picker>

        </app-box-wrapper>

        <app-box-wrapper class="mb-4"
                         :data-label="$t('message.generics.message.endDate')"
                         data-icon="mdi-calendar-range">

          <app-date-picker v-model="max"></app-date-picker>

        </app-box-wrapper>
      </div>

    </template>

  </app-dropdown>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import filter from "@mixins/filter";
import AppDropdown from "@components/Dropdown";
import AppBoxWrapper from "@components/BoxWrapper";
import AppDatePicker from "@components/DatePicker";
import AppTabSelector from "@components/TabSelector";

export default {
  components: {
    AppDropdown,
    AppBoxWrapper,
    AppDatePicker,
    AppTabSelector,
  },

  data() {
    return {
      key: "date",

      custom: false,

      tabs: [
        {
          label: this.$t('message.generics.message.fifteenDays'),
          value: {
            min: moment().subtract(15, "days").format("YYYY-MM-DD"),
            max: moment().format("YYYY-MM-DD"),
          },
        },
        {
          label: this.$t('message.generics.message.oneMonth'),
          value: {
            min: moment().subtract(1, "months").format("YYYY-MM-DD"),
            max: moment().format("YYYY-MM-DD"),
          },
        },
        {
          label: this.$t('message.generics.message.sixMonths'),
          value: {
            min: moment().subtract(6, "months").format("YYYY-MM-DD"),
            max: moment().format("YYYY-MM-DD"),
          },
        },
        {
          label: this.$t('message.generics.message.general'),
          value: {
            min: null,
            max: null,
          },
        },
      ],
    };
  },

  computed: {
    min: {
      get() {
        return this.value.min;
      },
      set(value) {
        this.value = {
          ...this.value,
          min: value,
        };
      },
    },

    max: {
      get() {
        return this.value.max;
      },
      set(value) {
        this.value = {
          ...this.value,
          max: value,
        };
      },
    },
  },

  mixins: [filter],

  mounted() {
    this.value = _.find(this.tabs, (tab) => {
      return tab.label === this.$t('message.generics.message.general');
    }).value;
  },
};
</script>

<style lang="scss" scoped>
.btn-gradient {
  font-size: 14px;
}

.date-range-filter {
  ::v-deep .dropdown-menu {
    overflow: visible;
  }

  .date-range-filter-body {
    flex-direction: column;
  }
}
</style>
